import React from 'react';
import AppImage from '@/components/ui/AppImage';

const MastheadHero: React.FC = () => {
  return (
    <section className="pt-16 pb-0 relative overflow-hidden">
      {/* Top ruled lines */}
      <div className="max-w-7xl mx-auto px-6 pt-8">
        <div className="ruled-line anim-masthead-title" />

        {/* Masthead title */}
        <div className="py-5 text-center anim-masthead-title">
          <h1
            className="font-display font-black tracking-tight leading-none select-none"
            style={{
              fontSize: 'clamp(3.5rem, 10vw, 9rem)',
              color: 'var(--color-charcoal)',
              letterSpacing: '-0.03em'
            }}>
            
            AIRCHECK
          </h1>
        </div>

        <div className="ruled-line" />

        {/* Dateline row */}
        <div
          className="flex flex-col sm:flex-row items-center justify-between py-3 gap-2 anim-dateline">
          
          {/* Left: volume info */}
          <div className="flex items-center gap-4">
            <span
              className="section-label"
              style={{ color: 'var(--color-charcoal-light)' }}>
              
              Vol. IX &nbsp;·&nbsp; Est. 2018
            </span>
            <span
              className="hidden sm:block section-label"
              style={{ color: 'var(--color-cream-border)', fontSize: '0.6rem' }}>
              
              ——
            </span>
            <span
              className="section-label"
              style={{ color: 'var(--color-brass)' }}>
              
              No. 147 &nbsp;·&nbsp; On the Craft of Listening
            </span>
          </div>

          {/* Right: tagline */}
          <span
            className="font-display italic text-sm"
            style={{ color: 'var(--color-charcoal-light)' }}>
            
            A show about making shows.
          </span>
        </div>

        <div className="ruled-line-thin" />
      </div>

      {/* Hero photo */}
      <div
        className="relative w-full anim-photo"
        style={{ height: 'clamp(280px, 45vw, 560px)' }}>
        
        <AppImage
          src="https://img.rocket.new/generatedImages/rocket_gen_img_11cd7bbfa-1772086994228.png"
          alt="Two hosts mid-conversation across a table crowded with vintage microphones, coffee mugs, and scribbled index cards in a converted radio booth, shot from slightly above"
          fill
          className="object-cover photo-sepia"
          priority />
        
        {/* Gradient overlays for depth */}
        <div
          className="absolute inset-0"
          style={{
            background:
            'linear-gradient(to bottom, rgba(245,240,232,0.15) 0%, transparent 30%, transparent 70%, rgba(245,240,232,0.6) 100%)'
          }} />
        
        {/* Episode badge overlay */}
        <div
          className="absolute bottom-6 right-6 corner-marks"
          style={{
            background: 'rgba(245,240,232,0.92)',
            backdropFilter: 'blur(8px)',
            border: '1px solid rgba(59,58,54,0.15)',
            padding: '14px 20px',
            borderRadius: '2px',
            maxWidth: '240px'
          }}>
          
          <p className="ep-badge">Latest Episode</p>
          <p
            className="font-display font-semibold text-base leading-snug"
            style={{ color: 'var(--color-charcoal)' }}>
            
            No. 147 — On the Craft of Listening
          </p>
          <p
            className="font-body text-xs mt-1"
            style={{ color: 'var(--color-charcoal-light)' }}>
            
            With guest Jad Abumrad
          </p>
        </div>
      </div>

      {/* Sub-masthead italic line */}
      <div className="max-w-7xl mx-auto px-6">
        <div className="ruled-line-thin" />
        <div
          className="py-4 flex flex-col sm:flex-row items-center justify-between gap-3 anim-subhead">
          
          <p
            className="font-display italic text-lg"
            style={{ color: 'var(--color-charcoal)' }}>
            
            "The podcast about podcasting that doesn't waste your time."
          </p>
          <a
            href="#rundown"
            className="btn-brass text-sm px-5 py-2.5 rounded-sm flex items-center gap-2 flex-shrink-0">
            
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
            </svg>
            Get the Rundown
          </a>
        </div>
        <div className="ruled-line-thin" />
      </div>
    </section>);

};

export default MastheadHero;